import * as conversationStatuses from 'modules/common/constants/conversationStatuses';

export const CONVERSATION_STATUS_TITLES = {
  undefined: {
    iconName: '',
    title: {
      id: 'const.unknown',
      defaultMessage: '** Unknown',
    },
  },
  [conversationStatuses.ENDED]: {
    iconName: 'ended_call',
    title: {
      id: 'General.ConversationStatus.Ended',
      defaultMessage: '** Ended',
    },
  },
  [conversationStatuses.UNANSWERED]: {
    iconName: 'unable-to-connect',
    title: {
      id: 'General.ConversationStatus.Unanswered',
      defaultMessage: '** Unanswered',
    },
  },
  [conversationStatuses.DISCONNECTED]: {
    iconName: 'disconnect-call',
    title: {
      id: 'General.ConversationStatus.Disconnected',
      defaultMessage: '** Disconnected',
    },
  },
  [conversationStatuses.IN_PROGRESS]: {
    iconName: 'phone-rings',
    title: {
      id: 'General.ConversationStatus.InProgress',
      defaultMessage: '** In Progress',
    },
  },
  [conversationStatuses.CONNECTING]: {
    iconName: 'phone-rings',
    title: {
      id: 'General.ConversationStatus.Connecting',
      defaultMessage: '** Connecting',
    },
  },
  [conversationStatuses.DECLINED]: {
    iconName: 'hangout',
    title: {
      id: 'General.ConversationStatus.Declined',
      defaultMessage: '** Declined',
    },
  },
  [conversationStatuses.DROPPED]: {
    iconName: 'hung-up-arrow-down',
    title: {
      id: 'General.ConversationStatus.Dropped',
      defaultMessage: '** Dropped',
    },
  },
  [conversationStatuses.PENDING]: {
    iconName: 'hourglass',
    title: {
      id: 'General.ConversationStatus.Pending',
      defaultMessage: '** Pending',
    },
  },
};
